module.exports = __webpack_public_path__ + "static/media/avatar.cb810e86.png";